<template>
  <div id>
    <v-container fluid class="pt-0">
      <v-dialog :max-width="500" v-model="show_add">
        <add-template @add="addTemplate" @close="show_add=false"></add-template>
      </v-dialog>
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-card style="min-height:85vh" class="admin_secondary">
            <v-card-title class="secondary white--text">
              Website Notification Templates
              <v-spacer></v-spacer>
              <v-btn icon dark @click="load" :loading="loading">
                <v-icon>fa-sync</v-icon>
              </v-btn>
            </v-card-title>

            <v-container class>
              <v-row align="center">
                <v-col cols="12" md="4" lg="3" xl="2">
                  <v-text-field
                    v-model="search"
                    append-icon="fa-search"
                    dark
                    label="Search"
                    outlined
                    hide-details
                    clearable
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4" lg="3" xl="2">
                  <v-select
                    outlined
                    hide-details
                    clearable
                    dark
                    label="Filter Group"
                    placeholder="All"
                    :items="filters"
                    v-model="filter"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4" lg="3" xl="2">
                  <v-switch label="Active Only" v-model="show_active_only" dark color="green"></v-switch>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="4" lg="3" xl="2" class="text-right">
                  <v-btn dark small fab color="green" @click="show_add=true">
                    <v-icon small>fa-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-data-table
                show-expand
                :loading="loading"
                :headers="headers"
                :items="items"
                :search="search"
              >
                <template v-slot:item.active="{ item }">
                  <v-icon v-if="item.active===1" color="green" small>fa-circle</v-icon>
                  <v-icon v-else color="grey" small>far fa-circle</v-icon>
                </template>

                <template v-slot:item.action="{  }">
                  <v-btn icon small color="primary">
                    <v-icon small>fa-edit</v-icon>
                  </v-btn>
                </template>

                <template v-slot:expanded-item="{ headers,item }">
                  <td :colspan="headers.length" class="pa-0">
                    <email-template :value="item" @input="item=$event"></email-template>
                  </td>
                </template>
              </v-data-table>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import headersEmail from "@/assets/table_headers/admin_notification_templates.json";
import emailTemplate from "@/components/notifications/website";
import addTemplate from "@/components/notifications/add";

export default {
  name: "",
  components: {
    emailTemplate,
    addTemplate
  },
  data: () => ({
    show_active_only: false,
    show_add: false,
    search: "",
    filter: "",
    filters: ["General", "Portals", "Marketing"],
    loading: false,
    modified: false,
    templates: []
  }),
  watch: {
    templates: {
      handler: function() {
        this.modified = true;
      },
      deep: true
    }
  },
  computed: {
    headers() {
      return headersEmail;
    },
    items() {
      return this.templates.filter(
        function(i) {
          if (this.show_active_only) {
            if (i.active === 0) {
              return false;
            }
          }
          if (this.filter) {
            if (i.group === this.filter) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        }.bind(this)
      );
    }
  },
  created() {
    this.load();
  },
  methods: {
    async addTemplate(template) {
      this.loading = true;
      this.show_add = false;
      try {
        await this.$api.post(`/admin/notification-templates`, template);
        this.load();
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    },
    async load() {
      this.loading = true;
      this.templates = await this.$api(`/admin/notification-templates`);
      setTimeout(
        function() {
          this.modified = false;
        }.bind(this),
        100
      );
      this.loading = false;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
